import type { PlanWeek } from '../types';
import type { Tracer } from '../tracer';

/**
 * Deload rule — every 4th week, mark `is_deload = true` and reduce volume by
 * 40% (drop one set per exercise where possible, with a floor of 2 sets).
 *
 * Why every 4th week: standard hypertrophy and strength block planning.
 */
export function deloadRule(weeks: PlanWeek[], trace: Tracer): PlanWeek[] {
  const DELOAD_CADENCE = 4;
  const VOLUME_DROP = 0.4; // 40% drop in sets, floored at 2

  let deloadCount = 0;

  for (const week of weeks) {
    if (week.week_number % DELOAD_CADENCE !== 0) continue;
    week.is_deload = true;
    deloadCount++;
    for (const day of week.days) {
      for (const ex of day.exercises) {
        const targetSets = Math.round(ex.sets * (1 - VOLUME_DROP));
        ex.sets = Math.max(2, targetSets);
        ex.rpe_target = Math.max(5, ex.rpe_target - 2);
      }
    }
  }

  trace.emit(
    'deload',
    `${deloadCount} deload week(s) marked`,
    `Cadence: every ${DELOAD_CADENCE} weeks; volume drop ${VOLUME_DROP * 100}%, RPE -2.`,
    { weeks: weeks.length, deload_count: deloadCount },
  );

  return weeks;
}
